function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "inherit",
  fillRule: "nonzero",
  opacity: 0.7,
  d: "M5.507 2.82l.193.004C7.6 2.918 9 4.518 9 6.306v.753c0 1.13-.6 2.07-1.5 2.73l2.7 1.882c.5.376.8.94.8 1.505v1.883c0 .565-.4.941-1 .941H1c-.6 0-1-.376-1-.941V13.27c0-.565.3-1.13.8-1.506l2.7-1.977C2.6 9.13 2 8.188 2 7.058v-.94c0-1.883 1.7-3.389 3.7-3.294zM9.2 2.258C9.7 1.412 10.7.753 11.9.94 13.1 1.13 14 2.26 14 3.388v.847c0 .66-.3 1.224-.7 1.6l1.8 1.13c.6.376.9.94.9 1.6v.753c0 .564-.4.94-1 .94h-3.4c0-.093-1.2-.94-1.2-.94.4-.66.6-1.506.6-2.353v-.941c0-1.506-.7-2.824-1.8-3.765z"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.42bc0ff2.svg";
export { ForwardRef as ReactComponent };